// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","joinCapIntroPage":"_6Xt1qLaYTCKZWnE65RAzO","joinCapIntroPageHaveQuestions":"lzyxMFE9YtloYUzkGoRs-","joinCapIntroPageScrollDown":"_3ehsTTYnIQlSqNo0xCuTF-"};